import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "mt-4 max-w-3xl mx-auto sm:px-6 lg:px-8 overflow-x-hidden" }
const _hoisted_3 = { class: "p-4 bg-white" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = { class: "ml-3 text-s text-gray-500" }
const _hoisted_10 = { class: "mt-4 group block w-full aspect-w-10 aspect-h-7 overflow-hidden" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "ml-2 text-sm text-gray-400" }
const _hoisted_15 = { class: "flex items-center justify-center" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "mt-4 p-4 bg-white"
}
const _hoisted_18 = { class: "min-w-0 flex-1" }
const _hoisted_19 = { class: "relative" }
const _hoisted_20 = { class: "border border-gray-300 rounded-lg shadow-sm overflow-hidden" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "comment",
  class: "sr-only"
}, "コメントを入力しましょう", -1)
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "py-2",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "py-px" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-9" })
  ])
], -1)
const _hoisted_24 = { class: "absolute bottom-0 inset-x-0 pl-3 pr-2 py-2 flex justify-between" }
const _hoisted_25 = { class: "flex items-center space-x-5" }
const _hoisted_26 = { class: "flex items-center" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "flex-shrink-0" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_31 = { class: "flex bg-white p-2" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "ml-2 flex-1 space-y-1" }
const _hoisted_34 = { class: "flex items-center justify-between" }
const _hoisted_35 = { class: "text-sm font-medium text-gray-400" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = {
  key: 0,
  class: "mt-4 flex overflow-x-auto space-x-5"
}
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "mx-2 mt-2 flex items-center" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "ml-4 text-sm text-gray-400" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "grow" }, null, -1)
const _hoisted_44 = { class: "text-xs text-gray-400" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "h-8" }, null, -1)
const _hoisted_46 = {
  key: 2,
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_48 = { class: "fixed z-10 inset-0 overflow-y-auto" }
const _hoisted_49 = { class: "flex items-center justify-center min-h-full p-4 text-center md:w-[80%] sm:p-0" }
const _hoisted_50 = { class: "relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all w-[80%] sm:my-8 sm:max-w-sm sm:w-full sm:p-6" }
const _hoisted_51 = { class: "flex justify-end items-center" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("h3", {
  class: "mx-auto text-lg leading-6 font-medium text-gray-900",
  id: "modal-title"
}, " スタンプを押した方 ", -1)
const _hoisted_53 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_54 = { class: "mt-2" }
const _hoisted_55 = ["src"]
const _hoisted_56 = { class: "flex items-center" }
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "flex flex-col" }
const _hoisted_59 = { class: "ml-3 text-s text-gray-500" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_62 = { class: "relative w-full transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6" }
const _hoisted_63 = { class: "mt-5 sm:mt-6" }
const _hoisted_64 = { class: "group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-indigo-500 overflow-hidden" }
const _hoisted_65 = ["src"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["onClick"]

import { formatSnsTime } from "@/utils/TextUtil";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { uuid } from "vue-uuid";
import { useStore } from "vuex";
import { Storage } from "aws-amplify";
import { MediaResource } from "@/models/MediaResource";
import Stamp from "@/models/Stamp";
import Timeline from "@/models/Timeline";
import Comment from "@/models/Comment";

import AppHeader from "@/components/AppHeader.vue";
import Decedent from "@/models/Decedent";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineDetailView',
  setup(__props) {

const store = useStore();
const route = useRoute();

const timeline_id = ref<string>("");
const timeline = ref<Timeline>({} as Timeline);
const comments = ref<Comment[]>([]);

const decedent = ref<Decedent | null>(null);

const comment = ref<string>("");

const show_stamped_user_list = ref<boolean>(false);
const stamped = ref<boolean>(false);

const showing_modal = ref<boolean>(false);
const target_comment = ref<Comment | null>(null);

const formatCommentTime = (datetime: Date | null) => {
  return formatSnsTime(datetime);
};

const canPostComment = computed<boolean>(() => {
  if(!timeline.value) {
    return false;
  }

  if(timeline.value && timeline.value.type == "temple_information") {
    return true;
  }
  return decedent.value && decedent.value!.is_accept_comment;
});

const refresh = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      await refreshTimeline();

      await Promise.all([refreshComments(), refreshStamped()]);
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const refreshTimeline = async () => {
  timeline.value = await Timeline.get(timeline_id.value, store.state.customer!.id);

  if (timeline.value && (timeline.value?.type == "pray" || timeline.value?.type == "album" || timeline.value?.type == "event")) {
    decedent.value = await Decedent.get(timeline.value!.target_id);
  }
};

const refreshComments = async () => {
  const result = await Comment.search(
    timeline_id.value,
    store.state.customer!.id
  );
  // console.log(result);
  comments.value = result.comments;
};

const refreshStamped = async () => {
  const stamp = await Stamp.get(timeline.value.id, store.state.customer!.id);
  stamped.value = !!stamp;
};

const uploadfile = ref<HTMLInputElement>();

const onAttachmentButtonClicked = () => {
  const element = uploadfile.value;
  element?.click();
};

const comment_resource_url = ref<string>("");

const onUploadFileChanged = (e: Event) => {
  // console.log(e);

  const element = e.target as HTMLInputElement;
  if (!element.files) {
    return;
  }

  const file = element.files![0];

  if (!file) {
    return;
  }

  const split = file.name.split(".");
  const filename = uuid.v4();
  const extension = split[split.length - 1];
  const contentType = extension == "png" ? "image/png" : "image/jpg";
  setTimeout(async () => {
    Storage.configure({ customPrefix: { public: "comments" } });
    const s3response = await Storage.put(`/${filename}.${extension}`, file, {
      contentType: contentType,
    });
    // console.log(s3response);
    comment_resource_url.value = `${process.env.VUE_APP_HOST}/comments/${filename}.${extension}`;
  });
};

const postComment = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      // console.log(comment.value);

      if (!store.state.customer) {
        return;
      }

      const urls: MediaResource[] = [];
      if (comment_resource_url.value) {
        urls.push(new MediaResource(comment_resource_url.value, null, null));
      }

      const temp = new Comment(
        "",
        0,
        "",
        "",
        "",
        "",
        comment.value,
        urls,
        0,
        false,
        new Date(),
        new Date(),
        null
      );
      temp.is_posting = true;
      comments.value.unshift(temp);

      comment_resource_url.value = "";
      comment.value = "";

      const registered = await Comment.register(
        timeline_id.value,
        store.state.customer!.id,
        temp.comment,
        temp.media_urls
      );

      if (!registered) {
        comments.value.splice(comments.value.indexOf(temp), 1);
      } else {
        comments.value.splice(comments.value.indexOf(temp), 1);
        comments.value.unshift(registered);
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const is_stamping = ref<boolean>(false);

const toggleStamp = () => {
  // $store.dispatch("setLoading", true);
  if (is_stamping.value) {
    return;
  }
  is_stamping.value = true;
  setTimeout(async () => {
    try {
      // console.log(comment);

      if (!store.state.customer) {
        return;
      }

      if (timeline.value.stamped) {
        timeline.value.stamp_count = timeline.value.stamp_count - 1;
        timeline.value.stamped = false;

        const success = await Timeline.deleteStamp(
          timeline.value.id,
          store.state.customer!.id
        );

        if (!success) {
          timeline.value.stamp_count = timeline.value.stamp_count + 1;
          timeline.value.stamped = true;
        }
      } else {
        timeline.value.stamp_count = timeline.value.stamp_count + 1;
        timeline.value.stamped = true;

        const success = await Timeline.postStamp(
          timeline.value.id,
          store.state.customer!.id,
          "hands_together"
        );

        if (!success) {
          timeline.value.stamp_count = timeline.value.stamp_count - 1;
          timeline.value.stamped = false;
        }
      }
    } finally {
      // $store.dispatch("setLoading", false);
      is_stamping.value = false;
    }
  });
};

const toggleCommentStamp = (comment: Comment) => {
  if (is_stamping.value) {
    return;
  }
  is_stamping.value = true;
  setTimeout(async () => {
    try {
      // console.log(comment);

      if (!store.state.customer) {
        return;
      }

      if (comment.stamped) {
        comment.stamp_count = comment.stamp_count - 1;
        comment.stamped = false;

        const success = await Comment.deleteCommentStamp(
          `${comment.timeline_id}_${comment.timestamp}`,
          store.state.customer!.id
        );

        if (!success) {
          comment.stamp_count = comment.stamp_count + 1;
          comment.stamped = true;
        }
      } else {
        comment.stamp_count = comment.stamp_count + 1;
        comment.stamped = true;

        const success = await Comment.postCommentStamp(
          `${comment.timeline_id}_${comment.timestamp}`,
          store.state.customer!.id,
          "like"
        );

        if (!success) {
          comment.stamp_count = comment.stamp_count - 1;
          comment.stamped = false;
        }
      }
    } finally {
      // $store.dispatch("setLoading", false);
      is_stamping.value = false;
    }
  });
};

const onMenuClicked = (comment: Comment) => {
  target_comment.value = comment;
  showing_modal.value = true;
};

const closeModal = () => {
  target_comment.value = null;
  showing_modal.value = false;
};

const deleteComment = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const target = target_comment.value!;
      await Comment.delete(target!.timeline_id, target!.timestamp);

      comments.value.splice(comments.value.indexOf(target), 1);

      closeModal();
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const reportComment = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const target = target_comment.value!;
      await Comment.report(target!.timeline_id, target!.timestamp, store.state.customer!.id);

      comments.value.splice(comments.value.indexOf(target), 1);

      closeModal();
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

onMounted(() => {
  timeline_id.value = route.params.timeline_id as string;
  timeline.value = {} as Timeline;

  refresh();
});

return (_ctx: any,_cache: any) => {
  const _component_fa = _resolveComponent("fa")!
  const _component_text_clamp = _resolveComponent("text-clamp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(AppHeader),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              class: "hidden h-8 w-8 rounded-full sm:block",
              src: 
                timeline.value.publisher_selfie_image_url ??
                require('@/assets/images/no-selfie.png')
              ,
              alt: ""
            }, null, 8, _hoisted_5),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  class: "h-8 w-8 rounded-full sm:hidden",
                  src: 
                    timeline.value.publisher_selfie_image_url ??
                    require('@/assets/images/no-selfie.png')
                  ,
                  alt: ""
                }, null, 8, _hoisted_7),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(timeline.value.publisher_name), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", null, _toDisplayString(timeline.value.title), 1),
          _createElementVNode("div", _hoisted_10, [
            (!!timeline.value.media_urls && !!timeline.value.media_urls.length)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: timeline.value.media_urls[0].original_resource_url,
                  alt: "",
                  class: "object-cover max-h-96 pointer-events-none group-hover:opacity-75"
                }, null, 8, _hoisted_11))
              : _createCommentVNode("", true)
          ]),
          (timeline.value.body)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "mt-4 mb-4",
                innerHTML: timeline.value.body
              }, null, 8, _hoisted_12))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "mt-4 flex items-center",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showStamps && _ctx.showStamps(...args)))
          }, [
            _createElementVNode("img", {
              class: "h-6 w-6",
              src: require('@/assets/images/ic_stamp1_circle.png')
            }, null, 8, _hoisted_13),
            _createElementVNode("span", _hoisted_14, _toDisplayString(timeline.value.stamp_count), 1),
            _createVNode(_component_fa, {
              icon: "angle-right",
              class: "ml-2 text-xl text-gray-400"
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              class: "ml-2 text-sm text-gray-400 flex items-center justify-center",
              onClick: toggleStamp
            }, [
              _createElementVNode("img", {
                class: "w-6 h-6 mr-2",
                src: 
                  timeline.value.stamped
                    ? require('@/assets/images/ic_stamp1_attention.png')
                    : require('@/assets/images/ic_stamp1.png')
                
              }, null, 8, _hoisted_16),
              _createTextVNode(" " + _toDisplayString(timeline.value.stamped ? "スタンプを消す" : "スタンプ"), 1)
            ])
          ])
        ]),
        (canPostComment.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("form", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _withDirectives(_createElementVNode("textarea", {
                      rows: "3",
                      name: "comment",
                      id: "comment",
                      class: "block w-full py-3 border-0 resize-none sm:text-sm",
                      placeholder: "コメントを入力しましょう",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((comment).value = $event))
                    }, null, 512), [
                      [_vModelText, comment.value]
                    ]),
                    (comment_resource_url.value)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "ml-2 mt-2 w-32",
                          src: comment_resource_url.value
                        }, null, 8, _hoisted_22))
                      : _createCommentVNode("", true),
                    _hoisted_23
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "-m-2.5 w-10 h-10 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-500",
                          onClick: _withModifiers(onAttachmentButtonClicked, ["prevent"])
                        }, [
                          _createVNode(_component_fa, { icon: "image" })
                        ], 8, _hoisted_27),
                        _createElementVNode("input", {
                          type: "file",
                          ref_key: "uploadfile",
                          ref: uploadfile,
                          class: "hidden",
                          accept: "image/*",
                          onChange: onUploadFileChanged
                        }, null, 544)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("button", {
                        type: "submit",
                        class: "inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-color-2",
                        onClick: _withModifiers(postComment, ["prevent"])
                      }, " コメントを投稿 ", 8, _hoisted_29)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (comments.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, (comment) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "py-4",
                    key: comment.timestamp
                  }, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("img", {
                        class: "h-6 w-6 rounded-full bg-gray-100",
                        alt: "",
                        src: 
                    comment.publisher_selfie_image_url ??
                    require('@/assets/images/no-selfie.png')
                  
                      }, null, 8, _hoisted_32),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("h3", _hoisted_35, _toDisplayString(comment.publisher_name), 1),
                          _createElementVNode("button", {
                            onClick: _withModifiers(($event: any) => (onMenuClicked(comment)), ["prevent"])
                          }, [
                            _createVNode(_component_fa, {
                              icon: "ellipsis-v",
                              class: "text-gray-400"
                            })
                          ], 8, _hoisted_36)
                        ]),
                        _createElementVNode("p", {
                          class: "text-s text-gray-600",
                          innerHTML: comment.comment_v
                        }, null, 8, _hoisted_37),
                        (comment.media_urls)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comment.media_urls, (media) => {
                                return (_openBlock(), _createElementBlock("img", {
                                  key: media.original_resource_url,
                                  src: media.original_resource_url,
                                  class: "w-64 rounded-sm"
                                }, null, 8, _hoisted_39))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["text-sm", {
                    'text-gray-400': !comment.stamped,
                    'underline': !comment.stamped,
                    'text-blue-400': comment.stamped,
                    'font-bold': comment.stamped,
                  }]),
                        onClick: ($event: any) => (toggleCommentStamp(comment))
                      }, " いいね! ", 10, _hoisted_41),
                      _createElementVNode("span", _hoisted_42, [
                        _createVNode(_component_fa, { icon: "thumbs-up" }),
                        _createTextVNode(" " + _toDisplayString(comment.stamp_count), 1)
                      ]),
                      _hoisted_43,
                      _createElementVNode("p", _hoisted_44, _toDisplayString(comment.is_posting
                      ? "投稿中..."
                      : formatCommentTime(comment.created_at)), 1)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_45,
        (show_stamped_user_list.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createElementVNode("button", {
                          class: "flex items-center justify-center h-8 w-8 rounded-full bg-gray-100",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (show_stamped_user_list.value = false))
                        }, [
                          _createVNode(_component_fa, { icon: "times" })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stamps, (stamp) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "flex items-center",
                              key: stamp.publisher_id
                            }, [
                              _createElementVNode("img", {
                                class: "hidden h-8 w-8 rounded-full sm:block",
                                src: 
                            stamp.publisher_selfie_image_url ??
                            require('@/assets/images/no-selfie.png')
                          ,
                                alt: ""
                              }, null, 8, _hoisted_55),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_56, [
                                  _createElementVNode("img", {
                                    class: "h-8 w-8 rounded-full sm:hidden",
                                    src: 
                                stamp.publisher_selfie_image_url ??
                                require('@/assets/images/no-selfie.png')
                              ,
                                    alt: ""
                                  }, null, 8, _hoisted_57),
                                  _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("span", _hoisted_59, _toDisplayString(stamp.publisher_name), 1)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (showing_modal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 w-full h-full",
          style: {"background-color":"#999999aa"},
          onClick: _withModifiers(closeModal, ["stop"])
        }, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  (!!target_comment.value!.media_urls && !!target_comment.value!.media_urls.length)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: target_comment.value!.media_urls[0].original_resource_url,
                        alt: "",
                        class: "object-cover pointer-events-none group-hover:opacity-75"
                      }, null, 8, _hoisted_65))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_text_clamp, {
                  text: target_comment.value!.comment,
                  "max-lines": 2,
                  class: "mt-2 block text-sm font-medium text-gray-900 pointer-events-none"
                }, null, 8, ["text"]),
                (target_comment.value!.publisher_id === _unref(store).state.customer.id)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "mt-8 inline-flex w-full justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm",
                      onClick: _withModifiers(deleteComment, ["stop"])
                    }, " このコメントを削除 ", 8, _hoisted_66))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "mt-8 inline-flex w-full justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm",
                  onClick: _withModifiers(reportComment, ["stop"])
                }, " このコメントを報告 ", 8, _hoisted_67)
              ])
            ])
          ])
        ], 8, _hoisted_60))
      : _createCommentVNode("", true)
  ]))
}
}

})